var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 24,
    viewBox: "0 0 117 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H0V0H18V4Z",
    fill: "#A1E2C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H0V7H18V11Z",
    fill: "#A1E2C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17H0V13H18V17Z",
    fill: "#A1E2C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H0V20H18V24Z",
    fill: "#A1E2C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0V23.9952L29.5364 24C33.4636 24 36.5373 22.9027 38.7226 20.729C40.9078 18.5553 42 15.6647 42 12.0494C42 8.43423 40.9078 5.54263 38.6877 3.33946C36.5024 1.10206 33.4297 0 29.5024 0H21ZM29.2317 20.1052H25.2705V3.89002H29.1968C35.1726 3.89002 37.7342 6.98891 37.7342 12.0494C37.7342 16.9721 35.1386 20.1052 29.2317 20.1052Z",
    fill: "#1C242A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 0V24H51.1746V15.4604H55.3151L60.2913 24H65L59.3551 14.4266C61.8953 13.3244 63.598 10.7422 63.598 7.60848C63.598 5.44006 62.8601 3.65017 61.3935 2.20361C59.9242 0.722806 58.1542 0 56.0503 0H47ZM55.6158 11.6029H51.1746V3.88984H55.9516C57.9531 3.88984 59.4566 5.4743 59.4566 7.67791C59.4566 9.98613 57.8867 11.6029 55.6158 11.6029Z",
    fill: "#1C242A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68 24V0H72V24H68Z",
    fill: "#1C242A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1648 24L73 0H77.6588L84.9976 17.664L92.3412 0H97L86.8352 24H83.1648Z",
    fill: "#1C242A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.152 0L93 24L97.6046 23.9981L99.5933 19.2114H110.407L112.395 24H117L106.848 0H103.152ZM109.047 15.6668H100.954L105 5.88801L109.047 15.6668Z",
    fill: "#1C242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logoBlack.48a2d327fbaaeb3b751dd31fdfc0fec7.svg";
export { ForwardRef as ReactComponent };